import { gql } from "@apollo/client";

export const QUERY_GIFT_VOUCHER_BY_CODE = gql`
  query GiftVoucherByCode($code: String!) {
    giftVoucherByCode(code: $code) {
      id
      code
      amount
      canBeRedeemed
      activatedDate
      expiryDate
    }
  }
`;

export const REDEEM_OUTSTANDING_GIFT_VOUCHERS = gql`
  mutation redeemOutstandingSaleGiftVouchers($saleId: ID!) {
    redeemOutstandingSaleGiftVouchers(saleId: $saleId) {
      id
    }
  }
`;
